RivalIQ.apps.Admin.apps.Company.module('views', function (views, App, Backbone, Marionette, $, _, async) {

    'use strict';

    views.TrackedPages = Marionette.CompositeView.extend({
        template: '#adminCompanyTrackedPagesTemplate',
        childView: views.TrackedPage,
        childViewContainer: '.tracked-pages',
        colWidth: 2,

        ui: {
            addPageBtn: '.x-add-page-btn',
            addPageInput: '.x-add-page-input'
        },

        events: {
            'click @ui.addPageBtn': 'addPage',
            'keypress @ui.addPageInput': 'onAddPageInputKeypress'
        },

        collectionEvents: {
            'change': 'render'
        },

        onAddPageInputKeypress: function (e) {
            const me = this;

            if (e.which === 13) {
                e.preventDefault();
                me.addPage();
            }
        },

        addPage: function () {
            const me = this;
            const url = $.trim(me.ui.addPageInput.val());

            if (url.length) {

                me.ui.addPageBtn.button('loading');

                const page = new RivalIQ.apps.Admin.models.TrackedPage({
                    url: url
                });

                const deferred = async.callbackToDeferred(function (error) {
                    me.ui.addPageBtn.button('reset');

                    if (error) {
                        return RivalIQ.execute('alert:error', error);
                    }

                    me.ui.addPageInput.val('');

                    if (me.collection.find({
                        id: page.get('id')
                    })) {
                        return RivalIQ.execute('alert:info', 'The URL entered resolved to a duplicate');
                    }

                    if (!page.id) {
                        return RivalIQ.execute('alert:danger', 'An error occurred adding this page, please try again');
                    }

                    me.collection.add(page);
                });

                page.save().done(deferred.resolve).fail(deferred.reject);
            }
        }

    });

    _.extend(views.TrackedPages.prototype, RivalIQ.views.rowNormalizer);

}, RivalIQ.utils.async);
